import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

// Logs a page view to the backend on every route change. Fire-and-forget:
// never blocks rendering and never surfaces errors to the visitor.
const VisitTracker = () => {
  const location = useLocation();

  useEffect(() => {
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/api/analytics/track`, {
        path: location.pathname,
      })
      .catch(() => {});
  }, [location.pathname]);

  return null;
};

export default VisitTracker;
